import { Link, useNavigate } from "react-router-dom";
import { LayoutGrid, ChevronDown, Droplets, UtensilsCrossed, Flower2, BadgePercent, Sparkles, Store } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const CATEGORY_MENU = [
  { name: "Limpieza", slug: "limpieza", to: "/shop?category=Limpieza", icon: Droplets, color: "text-green-600 bg-green-50", desc: "Lavandinas, detergentes, desengrasantes" },
  { name: "Bazar", slug: "bazar", to: "/shop?category=Bazar", icon: UtensilsCrossed, color: "text-blue-600 bg-blue-50", desc: "Vajilla, utensilios, accesorios" },
  { name: "Perfumería", slug: "perfumeria", to: "/shop?category=Perfumer%C3%ADa", icon: Flower2, color: "text-fuchsia-600 bg-fuchsia-50", desc: "Shampoo, jabones, cuidado personal" },
  { name: "Ofertas", slug: "ofertas", to: "/shop?category=Ofertas", icon: BadgePercent, color: "text-red-500 bg-red-50", desc: "Combos y descuentos del mes" },
  { name: "Novedades", slug: "novedades", to: "/shop?novedades=1", icon: Sparkles, color: "text-amber-600 bg-amber-50", desc: "Lo último que ingresó al depósito" },
];

const CategoriesMenu = ({ compact = false }) => {
  const navigate = useNavigate();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          className={`inline-flex items-center gap-2 rounded-full font-semibold text-sm transition-colors bg-slate-900 text-white hover:bg-slate-800 data-[state=open]:bg-green-600 ${compact ? "px-3 py-2" : "px-4 py-2.5"}`}
          data-testid="categories-dropdown-trigger"
        >
          <LayoutGrid className="w-4 h-4" />
          <span className={compact ? "hidden sm:inline" : ""}>Categorías</span>
          <ChevronDown className="w-4 h-4 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={10} className="w-72 p-2 rounded-2xl border-slate-200 shadow-xl bg-white/95 backdrop-blur-md" data-testid="categories-dropdown">
        {CATEGORY_MENU.map((c) => (
          <DropdownMenuItem
            key={c.slug}
            onSelect={() => navigate(c.to)}
            className="flex items-center gap-3 px-3 py-2.5 rounded-xl cursor-pointer focus:bg-slate-100"
            data-testid={`category-item-${c.slug}`}
          >
            <span className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${c.color}`}><c.icon className="w-4 h-4" /></span>
            <span className="flex-1 min-w-0">
              <span className="block font-semibold text-slate-900">{c.name}</span>
              <span className="block text-[11px] text-slate-500 truncate">{c.desc}</span>
            </span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator className="my-2 bg-slate-100" />
        <DropdownMenuItem onSelect={() => navigate("/shop")} className="px-3 py-2.5 rounded-xl cursor-pointer focus:bg-slate-100 font-semibold text-blue-700 flex items-center gap-2" data-testid="category-item-todos">
          <Store className="w-4 h-4" /> Ver toda la tienda
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const CategoryChips = ({ active }) => (
  <div className="flex flex-wrap gap-2" data-testid="category-chips">
    {CATEGORY_MENU.map((c) => (
      <Link
        key={c.slug}
        to={c.to}
        className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium border transition-all hover:-translate-y-0.5 hover:shadow-sm ${
          active === c.name ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-200 hover:border-slate-400"
        }`}
        data-testid={`category-chip-${c.slug}`}
      >
        <c.icon className={`w-3.5 h-3.5 ${active === c.name ? "" : c.color.split(" ")[0]}`} /> {c.name}
      </Link>
    ))}
  </div>
);

export default CategoriesMenu;
